// @flow

import R from 'ramda';
import { reducerWrapper } from '../support/utils';

import {
  SET_PRODUCT_NAME,
  MAU,
  GET_MONTH_TO_DATE_MAU,
  GET_EXPORT_WHITELIST,
  ADD_EXPORT_WHITELIST,
  REMOVE_EXPORT_WHITELIST,
  SUBSCRIPTIONS,
  CREATE_SUBSCRIPTION,
  CREATE_OLD_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_TIER,
  REMOVE_SUBSCRIPTION,
  SAVE_BILL_TO_CONTACT
} from '../actions/SubscriptionActions';

import NotificationActions from '../actions/NotificationActions';

import type { SubscriptionReducer } from '../types/subscriptionTypes';

function updateSubscriptions(state, data) {
  return R.map(v => {
    if (v.sku !== data.sku) {
      return v;
    }
    return Object.assign({}, v, data);
  }, state);
}

export var INIT_STATE: SubscriptionReducer = {
  loading: false,
  error: null,
  data: [],
  mau: null,
  isAppInExportWhitelist: false,
  productNameEdited: null,
  monthToDateMau: null,
  billToContact: null
};

export type Action = {
  type: string,
  data: Object
};

function Handler(state: SubscriptionReducer, action: Action) {
  const { data } = action;

  switch (action.type) {
    case SET_PRODUCT_NAME:
      return Object.assign({}, state, {
        productNameEdited: action.data.productName
      });

    case MAU.response:
      return Object.assign({}, state, { loading: false, mau: data.mau });

    case GET_MONTH_TO_DATE_MAU.response:
      return Object.assign({}, state, { loading: false, monthToDateMau: data });

    case GET_EXPORT_WHITELIST.response:
      return Object.assign({}, state, {
        loading: false,
        isAppInExportWhitelist: data.enable
      });

    case ADD_EXPORT_WHITELIST.response:
      return Object.assign({}, state, {
        loading: false,
        isAppInExportWhitelist: data.enable
      });

    case REMOVE_EXPORT_WHITELIST.response:
      return Object.assign({}, state, {
        loading: false,
        isAppInExportWhitelist: data.enable
      });

    case SUBSCRIPTIONS.response:
      return Object.assign({}, state, { loading: false, data });

    case CREATE_SUBSCRIPTION.response:
      if (state.productNameEdited) {
        NotificationActions.showNotification(
          `You successfully added ${state.productNameEdited}.`,
          'success'
        );
      }
      return Object.assign({}, state, {
        loading: false,
        data,
        productNameEdited: null
      });

    // TODO: Remove this once we disable DI1
    case CREATE_OLD_SUBSCRIPTION.response:
      NotificationActions.showNotification(
        `You successfully added ${data.name}.`,
        'success'
      );
      return Object.assign({}, state, {
        loading: false,
        data: updateSubscriptions(state.data, data)
      });

    case REMOVE_SUBSCRIPTION.response:
      NotificationActions.showNotification(
        `You successfully canceled ${data.name}.`,
        'success'
      );
      return Object.assign({}, state, {
        loading: false,
        data: updateSubscriptions(state.data, data)
      });

    case SAVE_BILL_TO_CONTACT.response:
      return Object.assign({}, state, { loading: false, billToContact: data });

    case UPDATE_SUBSCRIPTION_TIER.response:
      if (state.productNameEdited) {
        NotificationActions.showNotification(
          `You successfully updated ${state.productNameEdited}.`,
          'success'
        );
      }
      return Object.assign({}, state, {
        loading: false,
        data,
        productNameEdited: null
      });

    default:
      return state;
  }
}

const Subscriptions = reducerWrapper(INIT_STATE, Handler, {
  request: [
    MAU,
    GET_MONTH_TO_DATE_MAU,
    GET_EXPORT_WHITELIST,
    SUBSCRIPTIONS,
    CREATE_SUBSCRIPTION,
    CREATE_OLD_SUBSCRIPTION,
    UPDATE_SUBSCRIPTION_TIER,
    REMOVE_SUBSCRIPTION,
    SAVE_BILL_TO_CONTACT
  ],
  error: [
    MAU,
    GET_MONTH_TO_DATE_MAU,
    GET_EXPORT_WHITELIST,
    SUBSCRIPTIONS,
    CREATE_SUBSCRIPTION,
    CREATE_OLD_SUBSCRIPTION,
    UPDATE_SUBSCRIPTION_TIER,
    REMOVE_SUBSCRIPTION,
    SAVE_BILL_TO_CONTACT
  ],
  resetOn: ['APP_CHANGE']
});

export default Subscriptions;
